<div class="bary-table-list py-4 table-responsive">
  <table mdbTable [small]="true" [hover]="true">
    <thead>
      <tr class="tr-align-center grey-text">
        <th *ngIf="tableOptions?.isModerator"></th>
        <th colspan="2" class="tab-title text-center">
          <span jhiTranslate="baryApp.quotations.pickup">Pickup</span> -
          <span jhiTranslate="baryApp.quotations.delivery">Delivery</span>
        </th>
        <th colspan="4" class="tab-title text-center" jhiTranslate="baryApp.quotations.items">Items</th>
        <th colspan="4" class="tab-title text-center" jhiTranslate="baryApp.quotations.info">Info</th>
      </tr>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" #headers (sortChange)="transition()" jhiSort>
        <th jhiSortBy="client" *ngIf="tableOptions?.isModerator">
          <span jhiTranslate="baryApp.quotations.client">Client</span>
        </th>
        <th>
          <div class="row">
            <span class="mr-3" jhiTranslate="LABEL.PICKUP_DATE">Pickup Date</span>
          </div>
          <div class="row">
            <span jhiTranslate="LABEL.DELIVERY_DATE">Delivery Date</span>
          </div>
        </th>
        <th>
          <div class="row">
            <span jhiTranslate="LABEL.PICKUP_LOCATION">Pickup Location</span>
          </div>
          <div class="row">
            <span jhiTranslate="LABEL.DELIVERY_LOCATION">Pickup Location</span>
          </div>
        </th>
        <th jhiSortBy="totalUM">
          <span class="no-capitalize" jhiTranslate="LABEL.UM">Total UM</span>
        </th>
        <th jhiSortBy="totalWeight">
          <span jhiTranslate="LABEL.WEIGHT">Total Weight</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="totalVolume">
          <span jhiTranslate="baryApp.quotations.totalVolume">Total Volume</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th *ngIf="isPriceVisible()">
          <span class="no-capitalize" [jhiTranslate]="tableOptions?.isModerator ? 'LABEL.PRE_TAXES_PRICE' : 'LABEL.FULL_TAXES_PRICE'">Price</span>
        </th>
        <th jhiSortBy="pickupReference">
          <span jhiTranslate="baryApp.quotations.pickupReference">Pickup Reference</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="quotationStatus">
          <span jhiTranslate="baryApp.quotations.status">Status</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th *ngIf="tableOptions?.state === 'ONGOING'">
          <span jhiTranslate="baryApp.quotations.validityDate"></span>
        </th>
        <th class="text-center p-1" *ngIf="tableOptions?.isModerator && tableOptions?.state !== 'NEW'">
          <span jhiTranslate="unvalidatedBaskets.list.head.events"></span>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody *ngFor="let transport of transports; trackBy: trackId">
      <tr mdbTableRow>
        <td *ngIf="tableOptions?.isModerator">
          <a [routerLink]="[PATHS.MIDDLE_CUSTOMER_ID_DATA.withId(transport.customerId)]">
            {{ transport.customerName }}
          </a>
        </td>
        <td>
          <div class="row">
            <span>{{ transport.pickupDate?.toDate() | date: 'dd/MM/yyyy' }}</span>
          </div>
          <div class="row">
            <span>{{ transport.deliveryDate?.toDate() | date: 'dd/MM/yyyy' }}</span>
          </div>
        </td>
        <td>
          <div class="row">
            <span class="no-capitalize">{{ transport.pickupAddressCity ? transport.pickupAddressCity : '' }} , {{ transport.pickupAddressCountry | countryNameStandalone }}</span>
          </div>
          <div class="row">
            <span class="no-capitalize"
              >{{ transport.deliveryAddressCity ? transport.deliveryAddressCity : '' }} , {{ transport.deliveryAddressCountry | countryNameStandalone }}</span
            >
          </div>
        </td>
        <td>
          <span [mdbTooltip]="getTotalUMTooltip(transport)">{{ totalUM(transport) }}</span>
        </td>
        <td>
          <span>{{ transport.totalWeight || 0 | measureUnit: 'weight':true }}</span>
        </td>
        <td>
          <span>{{ transport.totalVolume || 0 | measureUnit: 'volume' }}</span>
        </td>
        <td *ngIf="isPriceVisible()">
          <span *ngIf="transport.quotationStatus && transport.quotationPriceHT">{{
            (tableOptions?.isModerator ? transport.quotationPriceHT : calculatePriceTTCFromPriceHT(transport.quotationPriceHT)) | currency: 'EUR'
          }}</span>
        </td>
        <td>
          <span>{{ transport.pickupReference ?? '/' }}</span>
        </td>
        <td>
          <jhi-bary-badge [options]="transport.quotationStatusBadgeOpts(tableOptions?.isModerator)"></jhi-bary-badge>
        </td>
        <td *ngIf="tableOptions?.state === 'ONGOING'">
          <span>{{ transport.quotationValidityDate?.toDate() | date: 'dd/MM/yyyy' }}</span>
        </td>
        <td class="text-center p-1" *ngIf="tableOptions?.isModerator && tableOptions?.state !== 'NEW'">
          <ng-container *ngIf="(transport?.salesSupportActionsList || []).length > 0">
            <div
              *ngFor="let salesSupportAction of transport.salesSupportActionsList?.reverse() | slice: 0:1"
              jhiTranslate="{{ 'unvalidatedBaskets.error-shorty.' + salesSupportAction.typeSalesSupportActionsEnum }}"
              [translateValues]="{ date: getObjectFromJson(salesSupportAction.value).date, commercialFullName: getObjectFromJson(salesSupportAction.value).commercialFullName }"
            ></div>
            <a
              class="my-2 text-primary cursor-pointer"
              *ngIf="(transport?.salesSupportActionsList || []).length > 1"
              (click)="displayMoreEvent(transport.salesSupportActionsList!)"
              >{{ 'LABEL.SHOW_MORE' | translate }}</a
            >
          </ng-container>
        </td>
        <td class="p-1">
          <jhi-bary-cta [actions]="getCta(transport)" [idCypress]="transport.id + ''" (selectAction)="onSelectAction($event, transport)"></jhi-bary-cta>
        </td>
      </tr>
    </tbody>
    <tbody>
      <tr *ngIf="cols && cols > 0" [hidden]="transports && transports.length > 0">
        <td [colSpan]="cols" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="LABEL.NO_RESULT">No quotation</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
